<template>
  <div ref="whole_page" id="DigiLearningStyleBViewer">



  <vs-popup 
    title="Cannot Continue"
    id="formative-assessments-marked-popup" 
    :active.sync="isTaskBlocked">
    <p class="pb-2">Well done on completing your Formative Assessments! Your answers will be assessed by a registered Assessor. You will receive a notification regarding the outcome.</p>
    <div class="mt-3">
      <vs-button color="success" class="float-right" @click="isTaskBlocked = false">Close</vs-button>
    </div>
  </vs-popup>

  <div class="">
    <div class=""></div>
      <div class="">
        <vx-card class="glow-effect_bg-color__blend card__no-padding bg-color styleBHeading" v-if="true">
          <vx-input-group >
            <vs-button
              :disabled="true"
              size="large"
              class="button__fully-opaque button-text__left-align glow-effect_bg-color__blend header_button-item text__school-tertiary-color bg-color"
              type="filled"
              color="">
              {{moduleName}}
            </vs-button>
          </vx-input-group>
        </vx-card>

        <vx-card class="glow-effect_bg-color__blend card__no-padding bg-color"  v-if="false">
          <vx-input-group >
            <h1> Congratulations </h1>
            <h2
              :disabled="true"
              size="medium"
              class="button__fully-opaque button-text__left-align glow-effect_bg-color__blend header_button-item text__school-tertiary-color bg-color"
              type="filled"
              color="White">
              YOU HAVE SUCCESSFULLY <br> COMPLETED 
              {{ prerequisiteModuleName }}
            </h2>
          </vx-input-group>
        </vx-card>
      </div>
  </div>

    <div class="">
      <div class="mt-4 ">
        <ul style="margin-top: 3px;flex-wrap: wrap;">
          <div class="limit-width_fixed-scalable" style="text-align: left;">

            <div class="optionalTask mb-4" v-for="(maptaskdata, maptaskdataIndex) in mapTask" :key="'A'+maptaskdataIndex">
              <vx-input-group>
                <vs-button
                  size="large"
                  :class="maptaskdata.isTaskComplete ? ' redGradiant' : 'task-open-background' "
                  class="w-full button-text__left-align optionalTaskbutton"
                  style="border-radius:2rem ; display: flex; "
                  @click="goToTask(maptaskdata)"
                  >
                  <div class="list-icon-position-optionalTask">
                    <span><feather-icon  class="pt-1" icon="ListIcon" svg-classes="stroke-current"></feather-icon></span>
                  </div>
                  {{"Map"}}
                  <div class="feather-icon-position-optionalTask append-text input-group_append-slot-bg">
                    <span v-if="maptaskdata.isTaskComplete"><feather-icon  class="pt-1" icon="CheckCircleIcon" svg-classes="stroke-current"></feather-icon></span>
                    <span v-else><feather-icon  class="pt-1" icon="ArrowRightCircleIcon" svg-classes="stroke-current"></feather-icon></span>
                  </div>
                </vs-button>
              </vx-input-group>
            </div>
            <div v-if="introductionVideoTask.length != 0">
              <div class="optionalTask mb-4"  v-for="(introductionVideoTaskdata, introductionVideoTaskdataIndex) in introductionVideoTask" :key="'B'+ introductionVideoTaskdataIndex">
                <vx-input-group>
                  <vs-button
                    size="large"
                    :class="!introductionVideoTaskdata.isTaskComplete && mapTaskCompleted  ? 'task-open-background' :  mapTaskCompleted ? 'redGradiant':'redGradiant button-disabled-opague ' "
                    class="w-full button-text__left-align optionalTaskbutton"
                    style="border-radius:2rem ; display: flex; "
                    :disabled="!mapTaskCompleted"
                    @click="goToTask(introductionVideoTaskdata)"
                    >
                    <div class="list-icon-position-optionalTask">
                      <span><feather-icon  class="pt-1" icon="ListIcon" svg-classes="stroke-current"></feather-icon></span>
                    </div>
                    <div style="width:100%;">
                      {{"Introduction Video"}}
                    </div>
                    <div class="feather-icon-position-optionalTask append-text input-group_append-slot-bg">
                      <span v-if="introductionVideoTaskdata.isTaskComplete"><feather-icon  class="pt-1" icon="CheckCircleIcon" svg-classes="stroke-current"></feather-icon></span>
                      <span v-else-if="introductionVideoTaskdata.isTaskOpen"><feather-icon  class="pt-1" icon="ArrowRightCircleIcon" svg-classes="stroke-current"></feather-icon></span>
                      <span v-else><feather-icon  class="pt-1" icon="LockIcon" svg-classes="stroke-current"></feather-icon></span>
                    </div>
                  </vs-button>
                </vx-input-group>
              </div>
            </div>
            <li v-for="(taskgroup, Index) in distinctTaskGroups" :key="Index" class="mb-4">

              <vx-card card-background="#11193f" class="glow-effect_dark limit-width_fixed-scalable card__no-padding border-radius-styleB" :class="getTaskGroupLocked(taskgroup.id ) ? 'button-disabled-opague':''">
                <div v-if="getTaskGroupLocked(taskgroup.id) && (getIntroductionGroupStatus(taskgroup.id))" class="aboveItem"></div>
                <app-collapse accordion type="border" class="text-left " >
                  <span v-if="getTaskGroupLocked(taskgroup.id)" class="absolute logo__for_collapse__dropdown"><feather-icon icon="LockIcon" svg-classes="stroke-current"></feather-icon></span>
                  <span v-else-if="getTaskGroupComplete(taskgroup.id)" class="absolute logo__for_collapse__dropdown"><feather-icon icon="CheckCircleIcon" svg-classes="stroke-current"></feather-icon></span>
                  <span v-else class="absolute logo__for_collapse__dropdown"><feather-icon icon="ArrowRightCircleIcon" svg-classes="stroke-current"></feather-icon></span>
                  <app-collapse-item :title="taskgroup.taskGroupName " class="open border-radius-styleB " :class="(!getTaskGroupLocked(taskgroup.id) && !getTaskGroupComplete(taskgroup.id) && getOptionalTasksStatus && (getIntroductionGroupStatus(taskgroup.id )) ) ? 'toggleBigOpen':''" >
                    <vx-input-group>

                      <div class="videoIntroductionTaskGroup mb-4" v-for="(introductionVideoForTaskGroupData, introductionVideoForTaskIndex) in introductionVideoForTaskGroup" :key="'C'+introductionVideoForTaskIndex">
                        <vx-input-group v-if="introductionVideoForTaskGroupData.taskGroupId == taskgroup.id">
                          <vs-button
                            size="large"
                            :class="(getOptionalTasksStatus) ? introductionVideoForTaskGroupData.isTaskOpen  ? 'task-open-background' : introductionVideoForTaskGroupData.isTaskLocked ? 'redGradiant button-disabled-opague' : 'redGradiant' :'redGradiant'"
                            class="button-text__left-align optionalTaskbutton"
                            :disabled="introductionVideoForTaskGroupData.isTaskLocked"
                            style="border-radius:2rem ; display: flex; width: 98% !important; margin: auto;"
                            @click="goToTask(introductionVideoForTaskGroupData)"
                            >
                            <div class="list-icon-position-optionalTask">
                              <span><feather-icon  class="pt-1" icon="ListIcon" svg-classes="stroke-current"></feather-icon></span>
                            </div>
                            <p style="width:inherit;">{{"introduction Video" }}</p>
                            <div class="feather-icon-position-optionalTask append-text input-group_append-slot-bg">
                              <span v-if="introductionVideoForTaskGroupData.isTaskComplete"><feather-icon  class="pt-1" icon="CheckCircleIcon" svg-classes="stroke-current"></feather-icon></span>
                              <span v-else-if="introductionVideoForTaskGroupData.isTaskOpen"><feather-icon  class="pt-1" icon="ArrowRightCircleIcon" svg-classes="stroke-current"></feather-icon></span>
                              <span v-else><feather-icon  class="pt-1" icon="LockIcon" svg-classes="stroke-current"></feather-icon></span>
                            </div>
                          </vs-button>
                        </vx-input-group>
                      </div>
                      
                      <li v-for="(outcome, Index) in getOutcomesForTaskGroup(taskgroup.id)" :key="Index" class="mb-3 innerList" >
                        <vx-card  class="glow-effect_dark limit-width_fixed-scalable card__no-padding cardlimit_width-container border-radius-styleB" :class="getOutcomeLocked(outcome.id,taskgroup.id) ? 'button-disabled-opague':getOutcomesOpen(outcome.id, taskgroup.id) ? 'task-open-background': ''">
                          <div v-if="getOutcomeLocked(outcome.id,taskgroup.id)" class="aboveItem"></div>
                          <app-collapse accordion type="border" class="text-left ">
                            <span v-if="getOutcomeLocked(outcome.id,taskgroup.id)" class="absolute logo__for_collapse__dropdown"><feather-icon icon="LockIcon" svg-classes="stroke-current"></feather-icon></span>
                            <span v-else-if="getOutcomeComplete(outcome.id,taskgroup.id)" class="absolute logo__for_collapse__dropdown"><feather-icon icon="CheckCircleIcon" svg-classes="stroke-current"></feather-icon></span>
                            <span v-else class="absolute logo__for_collapse__dropdown"><feather-icon icon="ArrowRightCircleIcon" svg-classes="stroke-current"></feather-icon></span>
                            <app-collapse-item :title="outcome.taskSpecificOutcomeName ? outcome.taskSpecificOutcomeName : 'Click to view Tasks'" class="border-radius-styleB" :class="(!getOutcomeLocked(outcome.id,taskgroup.id) && !getOutcomeComplete(outcome.id,taskgroup.id) ) ? 'toggleInnerOpen':''">
                              <vx-input-group style="margin: 0 Auto;">

                                <li v-for="(task, Index2) in moduleData.filter(x => x.taskSpecificOutcomeId == outcome.id && x.taskGroupId == taskgroup.id )" :key="Index2" class="mb-3 " >
                                  <vx-card card-background="#11193f" class="glow-effect_dark limit-width_fixed-scalable card__no-padding task_width-conainter" style="border-radius:2rem" >
                                    <template slot="prepend">
                                      <div class="prepend-text glow-effect_dark" style="background-color: #41475E;border-radius: 2rem 0 0 2rem !important;">
                                        <span><feather-icon class="pt-1" icon="CodesandboxIcon" svg-classes="stroke-current"></feather-icon></span>
                                      </div>
                                    </template>
                                    <vx-input-group>
                                      <vs-button
                                        size="large"
                                        :class="(getOptionalTasksStatus) ? task.isTaskComplete ? 'redGradiant' : task.isTaskOpen  ? 'task-open-background' : task.isTaskLocked ? 'redGradiant button-disabled-opague' : 'redGradiant' :'redGradiant' "
                                        class="w-full button-text__left-align"
                                        style="border-radius:2rem ; display: flex; "
                                        :disabled="(task.isTaskComplete ? false : task.isTaskOpen? false : task.isTaskLocked ? true : false )"
                                        @click="goToTask(task)"
                                        >
                                        {{ task.taskName }}
                                        
                                      </vs-button>
                                      <div class="feather-icon-position-learningstyleB append-text input-group_append-slot-bg">
                                          <span v-if="task.isTaskComplete"><feather-icon  class="pt-1 CheckCircleIcon" icon="CheckCircleIcon" svg-classes="stroke-current"></feather-icon></span>
                                          <span v-else-if="task.isTaskOpen && (mapTaskCompleted && introductionVideoTaskCompleted)"><feather-icon  class="pt-1 ArrowRightCircleIcon" icon="ArrowRightCircleIcon" svg-classes="stroke-current"></feather-icon></span>
                                          <span v-else><feather-icon  class="pt-1 LockIcon" icon="LockIcon" svg-classes="stroke-current"></feather-icon></span>
                                        </div>
                                      
                                    </vx-input-group>
                                    
                                  </vx-card>
                                </li>

                              </vx-input-group>
                            </app-collapse-item>

                          </app-collapse>
                        </vx-card>
                      </li>

                    </vx-input-group>
                  </app-collapse-item>

                </app-collapse>

              </vx-card>
            </li>
            <div class="optionalTask mb-4" v-for="(additionalMaterialTaskData, additionalMaterialTaskDataIndex) in additionalMaterialTask" :key="'C'+ additionalMaterialTaskDataIndex">
              <vx-input-group>
                <vs-button
                  size="large"
                  :class="additionalMaterialTaskData.isTaskComplete  ? 'redGradiant ' : 'task-open-background' "
                  class="w-full button-text__left-align optionalTaskbutton"
                  style="border-radius:2rem ; display: flex; "
                  @click="goToTask(additionalMaterialTaskData)"
                  >
                  <div class="list-icon-position-optionalTask">
                    <span><feather-icon  class="pt-1" icon="ListIcon" svg-classes="stroke-current"></feather-icon></span>
                  </div>
                  <div style="width:100%;">
                    Additional Material
                  </div>
                  <div class="feather-icon-position-optionalTask append-text input-group_append-slot-bg">
                    <span v-if="additionalMaterialTaskData.isTaskComplete && checkForMapTaskCompleted"><feather-icon  class="pt-1" icon="CheckCircleIcon" svg-classes="stroke-current"></feather-icon></span>
                    <span v-else ><feather-icon  class="pt-1" icon="ArrowRightCircleIcon" svg-classes="stroke-current"></feather-icon></span>
                  </div>
                </vs-button>
              </vx-input-group>
            </div>
          </div>
        </ul>
      </div>
    </div>

  </div>
</template>

<script>

import AppCollapse from '@/components/app-collapse/AppCollapse.vue';
import AppCollapseItem from '@/components/app-collapse/AppCollapseItem.vue';

export default {
  components: {
    AppCollapse,
    AppCollapseItem,
  },
  data() {
    return {
      moduleId: 0,
      moduleData: [],
      moduleName: "",
      taskGroups: [],
      distinctTaskGroups: [],
      prerequisiteModuleName: "",
      prerequisiteModuleLen: 0,
      temp: "",
      timeCapture:{
        captureTimeForAssessments: false,
        formativeHoursRequired: null,
        summativeHoursRequired: null,
        sliderMinFormatives: 0,
        sliderMaxFormatives: 0,
        sliderMinSummatives: 0,
        sliderMaxSummatives: 0,
        taskClassificationTypeId: 0,
      },
      isTaskBlocked:false,
      introductionVideoTask:[],
      mapTask:[],
      additionalMaterialTask:[],
      mapTaskCompleted:false,
      introductionVideoTaskCompleted:false,
      introductionVideoForTaskGroup:[],
      lastIndexOfOpenTaskGroup:0,
    };
  },
  computed: {
    getOptionalTasksStatus: function(){
      var self = this; 
      var returnValue = false;
      self.moduleData[0].isTaskOpen = false;
      self.moduleData[0].isTaskLocked = true;
      if(self.mapTaskCompleted && self.introductionVideoTaskCompleted){
        self.moduleData[0].isTaskOpen = true;
        self.moduleData[0].isTaskLocked = false;
        returnValue = true;
        if(self.moduleData[0].isTaskComplete){
          self.moduleData[0].isTaskOpen = false;
          self.moduleData[0].isTaskLocked = false;
        }
      }
      return returnValue;
    },
    
  },
  methods: {
    initValues(){
      this.moduleData = [];
      this.taskGroups = [];
      this.distinctTaskGroups = [];
      this.introductionVideoTask = [];
      this.mapTask = [];
      this.additionalMaterialTask =[];
      this.getmoduleData()
    },
    getmoduleData(){
      var self = this;
      var onSuccess = function (response) {
        self.introductionVideoTask = response.data.filter(x=> x.taskName.includes("IntroductionVideoTask"));
        self.introductionVideoForTaskGroup = response.data.filter(x=> x.taskName.includes("IntroductionVideo " + x.taskGroupName) );
        self.additionalMaterialTask = response.data.filter(x=> x.taskName.includes("AdditionalMaterialTask"));
        self.mapTask = response.data.filter(x=> x.taskName.includes("MapTask"));
        self.moduleData = response.data.filter(x=> !x.taskName.includes("IntroductionVideoTask") && !x.taskName.includes("IntroductionVideo") && !x.taskName.includes("AdditionalMaterialTask") && !x.taskName.includes("MapTask"));
        self.moduleName = self.moduleData[0].moduleName;
        //check if Map Task is complete
        if(self.mapTask.length != 0){
          self.mapTaskCompleted = self.mapTask[0].isTaskComplete;
          if(!self.mapTask[0].isTaskComplete){
            self.moduleData.forEach(element => {
              element.isTaskLocked = true;
              element.isTaskOpen = false;
            });
          } 
        }
        else{
          self.mapTaskCompleted = true;
        }
        //check if Introduction Video is complete
        if(self.introductionVideoTask.length != 0){
          self.introductionVideoTaskCompleted = self.introductionVideoTask[0].isTaskComplete;
          if(!self.introductionVideoTask[0].isTaskComplete){
            self.moduleData.forEach(element => {
              element.isTaskLocked = true;
              element.isTaskOpen = false;
            });
          } 
        }
        else{
          self.introductionVideoTaskCompleted = true;
        }

        //check if Introduction Video is completed
        
        
        self.getTimeCaptureDetail();

        self.getPrerequisiteModuleName();

        self.getDistinctTaskGroups();
      };
      var onFinally = function (response) {
        if(self.$refs.whole_page){
          self.$vs.loading.close(self.$refs.whole_page.$el);
        }
      } 

      self.$ajaxGet(self, "StudentModule/GetLearingStyleBModuleData?moduleId=" + self.moduleId, onSuccess, onFinally);
    },
    getIntroductionGroupStatus(taskgroupId){
      var self = this;
      if(self.introductionVideoForTaskGroup.length != 0){
        var element =  self.introductionVideoForTaskGroup.filter(x=>x.taskGroupId == taskgroupId);
        if(element.length != 0){
          return !element[0].isTaskLocked;
        }
        else{
          return false
        }
      }
      else{
        return true;
      }
    },
    getPrerequisiteModuleName(){
      var self = this;

      self.prerequisiteModuleName = self.moduleData.filter(x => x.prerequisiteModuleName && !x.isTaskLocked);
      self.prerequisiteModuleLen = self.prerequisiteModuleName.length;

      if(self.prerequisiteModuleLen){
        self.prerequisiteModuleName = self.prerequisiteModuleName[self.prerequisiteModuleLen - 1].prerequisiteModuleName;
      }
    },
    getTaskGroupLocked(taskGroupId){
      var self = this;
      
      var checkMap = self.checkForMapTaskCompleted();
      var taskGroupList = self.moduleData.filter(x => x.taskGroupId == taskGroupId);
      var isLockedList = taskGroupList.filter(x => x.isTaskLocked);
      if((isLockedList.length == taskGroupList.length) && !checkMap)
        return true;
      else
        return false;
    },
    getTaskGroupComplete(taskGroupId){
      var self = this;

      var taskGroupList = self.moduleData.filter(x => x.taskGroupId == taskGroupId);

      var isCompleteList = taskGroupList.filter(x => x.isTaskComplete);

      if(isCompleteList.length == taskGroupList.length)
        return true;
      else
        return false;
    },  
    getOutcomesOpen(outcomeId,taskGroupId){
      var self = this;

      var outcomeList = self.moduleData.filter(x => x.taskSpecificOutcomeId == outcomeId && x.taskGroupId == taskGroupId);

      var isOpenList = outcomeList.filter(x => x.isTaskOpen);

      if(isOpenList.length > 0)
        return true;
      else
        return false;
    },  
    getOutcomesForTaskGroup(taskGroupId){
      var self = this;
      return Array.from(new Set(self.moduleData.filter(x=>x.taskGroupId == taskGroupId).map(x=> x.taskSpecificOutcomeId))).map(id => {
        return {
          id: id, 
          taskSpecificOutcomeName: self.moduleData.find(x=>x.taskSpecificOutcomeId == id).taskSpecificOutcomeName,
        }
      });
    },
    getDistinctTaskGroups(){
      var self = this;
      self.distinctTaskGroups = Array.from(new Set(self.moduleData.map(x => x.taskGroupId))).map(id => {
        return {
          id: id,
          taskGroupName: self.moduleData.find(x => x.taskGroupId == id).taskGroupName,
          taskSpecificOutcomeId: self.moduleData.find(x => x.taskGroupId == id).taskSpecificOutcomeId,
          taskGroupNumber: self.moduleData.find(x => x.taskGroupId == id).taskGroupNumber
        }
      });
      self.distinctTaskGroups = self.distinctTaskGroups.sort(function(a,b){
        var sort1 = a.taskGroupNumber, sort2 = b.taskGroupNumber;
        if(sort1 < sort2)
          return -1;
        if(sort1 > sort2)
          return 1;
        return 0;
      });
    },
    getOutcomeLocked(outcomeId,taskGroupId){
      var self = this;
      var outcomeList = self.moduleData.filter(x => x.taskSpecificOutcomeId == outcomeId && x.taskGroupId == taskGroupId);
      var isLockedList = outcomeList.filter(x => x.isTaskLocked && !x.isTaskComplete);

      if(isLockedList.length == outcomeList.length)
        return true;
      else
        return false;
    },
    getOutcomeComplete(outcomeId,taskGroupId){
      var self = this;
      var outcomeList = self.moduleData.filter(x => x.taskSpecificOutcomeId == outcomeId && x.taskGroupId == taskGroupId);
      var isLockedList = outcomeList.filter(x => x.isTaskComplete);

      if(isLockedList.length == outcomeList.length)
        return true;
      else
        return false;
    },
    showLoadingOnElement(element, scale, type) {
      
      var self = this;
      self.$vs.loading({
        
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    goToTask(task){
      var self =this;
      var studentId = localStorage.getItem("Current_User_Id");
      var checkIfPreview = JSON.parse(localStorage.getItem("isStudent").toLowerCase());
      if(!checkIfPreview){
        if(task.taskTypeId == 9 ){
          self.$router.push({ name: 'StoryViewer', params: { mode: "story", taskDisplayId: task.taskDisplayId, moduleId: self.moduleId, isStudent: "false", coins: self.coins , styleB: true, taskClassificationTypeId: 9 } });
        }else if(task.taskTypeId == 2){
            self.$router.push({ name: "VideoViewer", query: { id: task.taskId, moduleId: self.moduleId, styleB: true, taskClassificationTypeId: 9 }});
        }else if(task.taskTypeId == 5){
          self.$router.push({ name: "DocumentViewer", query: { id: task.taskId, moduleId: self.moduleId, styleB: true, taskClassificationTypeId: 9 }});
        }else if(task.taskTypeId == 4){
          self.$router.push({ name: "StoryViewer", params: { mode: "story", taskDisplayId: task.taskDisplayId, moduleId: self.moduleId, isStudent: "false", coins: self.coins , styleB: true, taskClassificationTypeId: 9 } });
        }else if(task.taskTypeId == 6){
          self.$router.push({ name: "UploadViewer", query: { 
            id: task.taskId, 
            moduleId: self.moduleId, 
            styleB: true, 
            taskClassificationTypeId: 9,
            timeCapture: JSON.stringify(self.timeCapture)}});
        }else if(task.taskTypeId == 8){
          self.$router.push({ name: 'StoryViewer', params: { mode: "story", taskDisplayId: task.taskDisplayId, moduleId: self.moduleId, isStudent: "false", coins: self.coins , styleB: true, taskClassificationTypeId: 9 } });
        }
      }
      else{
        var onSuccess = response =>{
          if((task.taskClassificationTypeId == 2) && (response.data == 2 || response.data == 1)){
            self.isTaskBlocked = true;
            return;
          }
          else{
            if(task.taskTypeId == 9 ){
              self.$router.push({ name: 'StoryViewer', params: { mode: "story", taskDisplayId: task.taskDisplayId, moduleId: self.moduleId, isStudent: "true", coins: self.coins , styleB: true, taskClassificationTypeId: task.taskClassificationTypeId } });
            }else if(task.taskTypeId == 2){
              self.$router.push({ name: "VideoViewer", query: { id: task.taskId, moduleId: self.moduleId, styleB: true, taskClassificationTypeId: task.taskClassificationTypeId }});
            }else if(task.taskTypeId == 4){
              self.$router.push({ name: "StoryViewer", params: { mode: "story", taskDisplayId: task.taskDisplayId, moduleId: self.moduleId, isStudent: "true", coins: self.coins , styleB: true, taskClassificationTypeId: task.taskClassificationTypeId } });
            }else if(task.taskTypeId == 5){
              self.$router.push({ name: "DocumentViewer", query: { id: task.taskId, moduleId: self.moduleId, styleB: true, taskClassificationTypeId: task.taskClassificationTypeId }});
            }else if(task.taskTypeId == 6){
              self.$router.push({ name: "UploadViewer", query: { 
                id: task.taskId, 
                moduleId: self.moduleId, 
                styleB: true, 
                taskClassificationTypeId: task.taskClassificationTypeId,
                timeCapture: JSON.stringify(self.timeCapture)}});
            }else if(task.taskTypeId == 8){
              self.$router.push({ name: 'StoryViewer', params: { mode: "story", taskDisplayId: task.taskDisplayId, moduleId: self.moduleId, isStudent: "true", coins: self.coins , styleB: true, taskClassificationTypeId: task.taskClassificationTypeId } });
            }
          }
        };
        
        self.$ajaxGet(self, "StudentModule/GetStudentModuleStatusId?studentId=" + studentId + "&moduleId=" + task.moduleId, onSuccess);
      }
    },
    checkForMapTaskCompleted(){
      var self = this;
      if(self.mapTask.length != 0){
        self.mapTaskCompleted = self.mapTask[0].isTaskComplete;
        return self.mapTask[0].isTaskComplete
      }
      else
      return true
    },
    checkForintroductionVideoTaskCompleted(){
      var self = this;
      if(self.introductionVideoTask.length != 0){
        self.introductionVideoTaskCompleted = self.introductionVideoTask[0].isTaskComplete
        return self.introductionVideoTask[0].isTaskComplete
      }
      else
      return true
    },
    stopLoadingOnElement(element) {
      var self = this;
      self.$vs.loading.close(self.$refs[element].$el);
    },
    getTimeCaptureDetail(){
        var self = this;

        self.timeCapture.captureTimeForAssessments = self.moduleData[0].captureTimeForAssessments;
        self.timeCapture.formativeHoursRequired = self.moduleData[0].formativeHoursRequired;
        self.timeCapture.summativeHoursRequired = self.moduleData[0].summativeHoursRequired;

        var formativesCount = self.moduleData.filter(x => x.taskClassificationTypeId == 1).length;
        var summativesCount = self.moduleData.filter(x => x.taskClassificationTypeId == 2).length;

        self.timeCapture.sliderMinFormatives = Math.ceil(self.timeCapture.formativeHoursRequired/formativesCount);
        self.timeCapture.sliderMinSummatives = Math.ceil(self.timeCapture.summativeHoursRequired/summativesCount);

        self.timeCapture.sliderMaxFormatives = Math.ceil(self.timeCapture.sliderMinFormatives + (self.timeCapture.sliderMinFormatives * 50/100));
        self.timeCapture.sliderMaxSummatives = Math.ceil(self.timeCapture.sliderMinSummatives + (self.timeCapture.sliderMinSummatives * 50/100));
      },
    checkLastSummativeShowTimeCapture() {
      var self = this;

      var studentId = localStorage.getItem("Current_User_Id");

      var onSuccess = response =>{
        if(response.data === true){
          self.$router.push({ name: 'PracticalTimeCapture', query: { moduleId: self.moduleId } });
        }
      };
      
      self.$ajaxGet(self, "StudentModule/CheckIfLastSummativeHasBeenDone?studentId=" + studentId + "&moduleId=" + self.moduleId, onSuccess);
    }
  },
  mounted() {
    var self = this;
    
    self.showLoadingOnElement('whole_page', 1, 'material');
    if(Object.keys(self.$route.params).length == 0){
      if (self.$acl.check("Student")) {
        self.$router.push({ name: 'Menu' });
        return;
      }
    }

    self.moduleId = self.$route.params.moduleId ? self.$route.params.moduleId : self.$route.query.moduleId;

    if (self.$route.params.checkTimeCapture) {
      self.checkLastSummativeShowTimeCapture();
    }

    this.initValues();
  }
};
</script>

<style lang="scss">
  @import "@/digicampus/assets/main-digi.scss";
  
  .toggleBigOpen{
    & > .collapse{
      display: block !important;
    } 
  }

  .toggleOpen{
    div:not(div:nth-child(1)){
        
        display: unset !important;
        display: block !important ;
        
    }
  }

  .toggleInnerOpen{
    div:not(div:nth-child(1)){
        display: block !important ;
        
    }
  }

  .toggleClose{
    div:nth-child(2){
        display: unset !important;
        display: none !important;
    }
  }


  .styleBHeading{
    display: flex;
    justify-content: center;
    div{
      button{
        padding: 0px !important;
        text-align: center !important;
      }
    }
   .button__fully-opaque.vs-button:disabled{
    text-align: center !important;
  }
  }

  .optionalTask{
    button{
      height: 54px;
      display: flex;
      align-items: center;
    }
    .list-icon-position-optionalTask{
      margin-left: -20px;
      margin-right: 5px;
    }
    .optionalTaskbutton{
      .vs-button-text.vs-button--text{
        display: flex;
        align-items: center;
        width: 100%;
      }
    }
    .feather-icon-position-optionalTask{
      text-align: end;
      width: 100%;
    }
  }
  .videoIntroductionTaskGroup{
    button{
      height: 54px;
      display: flex;
      align-items: center;
    }
    .list-icon-position-optionalTask{
      margin-left: -20px;
      margin-right: 5px;
    }
    .optionalTaskbutton{
      .vs-button-text.vs-button--text{
        display: flex;
        align-items: center;
        width: 100%;
      }
    }
    .feather-icon-position-optionalTask{
      text-align: end;
      width: 100%;
    }
  }
</style>
